import type {
  SiteInvoicingReport,
  GrandfatheredSiteReport,
} from "../../services/client";

export const TIER_KEYS = [
  "small",
  "medium",
  "large",
  "extra_large",
  "custom",
] as const;

export type TierKey = (typeof TIER_KEYS)[number];

export const TIER_LABELS: Record<TierKey, string> = {
  small: "Small",
  medium: "Medium",
  large: "Large",
  extra_large: "Extra Large",
  custom: "Custom",
};

export const TIER_COLORS: Record<TierKey, string> = {
  small: "blue",
  medium: "green",
  large: "orange",
  extra_large: "red",
  custom: "purple",
};

export const TIER_FILTERS = TIER_KEYS.map((t) => ({
  text: TIER_LABELS[t],
  value: t,
}));

export function isTierKey(tier: string): tier is TierKey {
  return (TIER_KEYS as readonly string[]).includes(tier);
}

export function getSiteTier(
  site: SiteInvoicingReport | GrandfatheredSiteReport,
): string {
  const tierOrder: readonly string[] = TIER_KEYS;
  const acIdx = site.ac_tier ? tierOrder.indexOf(site.ac_tier) : -1;
  const dcIdx = site.dc_tier ? tierOrder.indexOf(site.dc_tier) : -1;
  const tier = acIdx >= dcIdx ? site.ac_tier : site.dc_tier;
  return tier ? (TIER_LABELS[tier] ?? tier) : "—";
}

export function formatCurrency(value: string | number): string {
  const num = typeof value === "number" ? value : parseFloat(value);
  return new Intl.NumberFormat("nl-BE", {
    style: "currency",
    currency: "EUR",
  }).format(num);
}
